import { ArrowRight, Globe2, PenTool, Settings2 } from "lucide-react";

const icons = [PenTool, Settings2, Globe2];

export function TrinityModel({ positioning, operatingModel, modelFlow }) {
  return (
    <section id="trinity-model" className="section trinity-model-section" data-testid="trinity-model-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="trinity-model-overline">{operatingModel.overline}</p>
        <h2 data-testid="trinity-model-title">{operatingModel.title}</h2>
        <p data-testid="trinity-model-description">{operatingModel.description}</p>
      </div>

      {modelFlow && modelFlow.length ? (
        <div className="model-flow" data-testid="model-flow">
          {modelFlow.map((step, index) => {
            const Icon = icons[index] || Settings2;
            return (
              <div className="model-flow-node" key={step} data-testid={`model-flow-step-${index + 1}`}>
                <Icon size={19} aria-hidden="true" />
                <span>{step}</span>
                {index < modelFlow.length - 1 ? <ArrowRight size={18} aria-hidden="true" /> : null}
              </div>
            );
          })}
        </div>
      ) : null}

      <div className="model-proof-grid" data-testid="trinity-model-grid">
        {operatingModel.cards.map((card, index) => {
          const Icon = icons[index];
          return (
            <article className="operating-card" key={card.title} data-testid={`trinity-model-card-${index + 1}`}>
              <div className="solution-icon" data-testid={`trinity-model-icon-${index + 1}`}>
                <Icon size={24} aria-hidden="true" />
              </div>
              <h3 data-testid={`trinity-model-card-title-${index + 1}`}>{card.title}</h3>
              <p data-testid={`trinity-model-card-text-${index + 1}`}>{card.text}</p>
              <ul data-testid={`trinity-model-card-list-${index + 1}`}>
                {card.items.map((item) => (
                  <li key={item} data-testid={`trinity-model-card-item-${index + 1}-${item.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>{item}</li>
                ))}
              </ul>
            </article>
          );
        })}
      </div>

      <div className="positioning-strip" data-testid="positioning-summary-strip">
        {positioning.cards.map(([title, text], index) => (
          <div key={title} data-testid={`positioning-summary-${index + 1}`}>
            <strong>{title}</strong>
            <span>{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}